// extracted by mini-css-extract-plugin
export default {"burger":"Burger_burger__QSJ9L","burgerItem":"Burger_burgerItem__8DBXq"};